import { render, staticRenderFns } from "./FormSetting.vue?vue&type=template&id=4a265896&"
import script from "./FormSetting.vue?vue&type=script&lang=js&"
export * from "./FormSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports